$(function () {
    if (!$('#gcv-comisiones-tienda').length) {
        return;
    }
    var H = GcvComisionesHelper;
    H.init({
        tableSelector: '#gcvComisionesTiendaTable',
        filterSelector: '#gcvComisionesTiendaFilter',
        searchButton: '#gcvComisionesTiendaBuscar',
        exportButton: '#gcvComisionesTiendaExportar',
        exportUrl: HOST + '/comisiones/tienda/export',
        dataUrl: HOST + '/comisiones/tienda/data',
        queryType: 'tienda',
        useUrlPagination: true,
        order: [[0, 'DESC']],
        totalesFields: ['comision_tienda', 'comision_tienda_prevista', 'comision_tienda_max_prevista'],
        columns: [
            {data: 'periodo', title: 'PERIODO', className: 'uk-text-center'},
            {data: 'comisionista', title: 'COMISIONISTA', className: 'uk-text-center'},
            {data: 'comision', title: 'DENOMINACIÓN COMISIÓN', className: 'uk-text-center'},
            H.pctUmbralViabilidadCol('mult_umb_via', '% UMB. VIAB.'),
            H.decimalCol('pct_stock_obsoleto', '% STOCK OBS.'),
            H.decimalCol('pto_exc_total', 'PTO EXC.'),
            H.decimalCol('mult_umb_via', 'MULT. VIAB.'),
            H.decimalCol('mult_umb_via_max', 'MULT. VIAB. MÁX.'),
            H.decimalCol('mult_pto_exc', 'MULT. EXC.'),
            H.decimalCol('mult_pto_exc_max', 'MULT. EXC. MÁX.'),
            H.decimalCol('comision_tienda', 'COM. TIENDA', true),
            H.decimalCol('pct_umbral_viabilidad_previsto', '% UMB. VIAB. PREV.'),
            H.decimalCol('mult_umb_via_previsto', 'MULT. VIAB. PREV.'),
            H.decimalCol('comision_tienda_prevista', 'COM. TIENDA PREV.', true),
            H.decimalCol('comision_tienda_max_prevista', 'COM. TIENDA PREV. MÁX.', true)
        ]
    });
});
